import { memo } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { QuestionCardItem } from "../../../system/question/card/card-item";

type Props = {
	question: string;
	option: ForNodeType<string>;
	onSetOptionItem: (input: string) => void;
	removeOptionItem: () => void;
};

export const QuestionPreQuestionItemOptions = memo(({ question, onSetOptionItem, option, removeOptionItem }: Props) => {
	return (
		<QuestionCardItem removeItem={removeOptionItem}>
			<div className="mt-2 space-y-4">
				{Boolean(question) && (
					<div className="space-y-1.5">
						<label className="text-sm">質問</label>
						<p className="line-clamp-2 text-sm">{question}</p>
					</div>
				)}
				<div>
					<InputTextField
						label="回答"
						value={option.value}
						handleChange={onSetOptionItem}
						errorMessage={option.error}
					/>
				</div>
			</div>
		</QuestionCardItem>
	);
});

QuestionPreQuestionItemOptions.displayName = "QuestionPreQuestionItemOptions";
